import moment from 'moment';
import { assetsApi } from '../api/assets.api';
import dayjs from 'dayjs';
import { getTenantHeader, setEmbedTenant } from '../embed/tenantHeader';

export { getTenantHeader, setEmbedTenant };

export const getBetweenDay = (startDate, endDate) => {
  if (!(startDate instanceof Date) || isNaN(startDate.valueOf())) {
    return;
  }
  if (!(endDate instanceof Date) || isNaN(endDate.valueOf())) {
    return;
  }
  let difference = endDate.getTime() - startDate.getTime();
  const betweenDay = Math.ceil(difference / (1000 * 3600 * 24));
  return betweenDay;
}

export const testValueInAry = (equips, field, status) => {
  let result = true;
  if (!Array.isArray(equips)) {
    return false;
  }
  equips.forEach((equip) => {
    if (equip[field] != status) {
      result = false;
    }
  });
  return result;
}

export const isValidDate = (dateString, split = '/') => {
  // First check for the pattern
  const euDate = /^\d{1,2}[\-,\/]\d{1,2}[\-,\/]\d{4}$/.test(dateString);
  if (!euDate)
    return '';

  // Parse the date parts to integers
  let year, month, day;
  var parts = dateString.split(split);

  if (euDate) {
    month = parseInt(parts[0], 10);
    day = parseInt(parts[1], 10);
    year = parseInt(parts[2], 10);
  }

  // Check the ranges of month and year
  if(year < 1000 || year > 3000 || month == 0 || month > 12)
      return '';

  var monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

  // Adjust for leap years
  if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0))
      monthLength[1] = 29;

  // Check the range of the day
  if(day > 0 && day <= monthLength[month - 1]) {
    const cMonth = month < 10 ? `0${month}` : month;
    const cDay = day < 10 ? `0${day}` : day;
    return [year, cMonth, cDay].join('-');
  }
  return '';
};

export const getDateFromMoment = (date) => {
  if (date)
    return moment(new Date(date)).format('YYYY-MM-DD');
  return '';
}

export const checkSessionCartItems = async (cartItems, localFilterDate, initCartItem = true) => {
  const updatedCartItems = [];
  for (let i = 0; i < cartItems.length; i++) {
    const item = { ...cartItems[i]};
    const result = await checkAssetAvailable(item.assetId, getDateFromMoment(localFilterDate?.pickupDate), localFilterDate?.pickupTime, getDateFromMoment(localFilterDate?.returnDate), localFilterDate?.returnTime);
    if (result) {
      updatedCartItems.push(result);
    } else {
      item['unavailable'] = true;
      if (!initCartItem)
        updatedCartItems.push(item);
    }
  }
  return updatedCartItems;
}

export const checkAssetAvailable = async (assetId, pickupDate, pickupTime, returnDate, returnTime) => {
  try {
    const { data } = await assetsApi.checkAssetAvailable(assetId, pickupDate, returnDate, pickupTime || '',  returnTime || '');

    if (data?.status === 'OK') {
      if (data?.assets?.length > 0) {
        return data.assets[0];
      }
      return false;
    }
  } catch (e) {
    return false;
  }
};
export const validateAssetRental = async (assetId, pickupDate, pickupTime, returnDate, returnTime) => {
  try {
    const { data } = await assetsApi.validateAssetRental(assetId, pickupDate, returnDate, pickupTime || '',  returnTime || '');

    return data;
  } catch (e) {
    return null;
  }
};
export const errorMessage = (err, defaultMsg ='Some error occurred. Please call support') => {
  let errMessage = defaultMsg;

  if (typeof err === 'string') {
    errMessage = err;
  }

  if (err) {
    const errData = err?.response?.data;

    if (errData) {
      errMessage = `${errData.status} - ${errData.error}`;
    }
  }

  return errMessage;
};

export const checkPastDate = (dateMoment, timeStr = '12:00', targetMoment = moment()) => {
  if (!dateMoment || !timeStr || !targetMoment) return false;
  const currentDate = new Date(dateMoment);
  const timeAry = timeStr.split(':');
  currentDate.setHours(parseInt(timeAry[0]));
  currentDate.setMinutes(parseInt(timeAry[1]));
  currentDate.setSeconds(0);
  currentDate.setMilliseconds(0);
  return targetMoment >= moment(currentDate);
}

export const getDateMoment = (dateMoment, timeStr = '12:00') => {
  if (!dateMoment || !timeStr) return moment();
  const currentDate = new Date(dateMoment);
  const timeAry = timeStr.split(':');
  currentDate.setHours(parseInt(timeAry[0]));
  currentDate.setMinutes(parseInt(timeAry[1]));
  currentDate.setSeconds(0);
  currentDate.setMilliseconds(0);
  return moment(currentDate);
}

export const convertToFt = (length) => {
  const feet = Math.floor(length / 12);
  const inches = (length - (feet * 12));
  let str = feet > 0 ? `${String(feet)}'` : '';
  str += (inches > 0 ? `${String(inches)}"` : '');
  return str;
};

export const getOwnerName = (str) => {
  if (str) {
    const ownerNameArray = str?.split(' ');

    let ownerName = String(ownerNameArray[0].charAt(0).toUpperCase())
    + String(ownerNameArray[0].substr(1));

    if (ownerNameArray.length > 1) {
      ownerName = String(ownerName) + String(' ') + String(ownerNameArray[1].charAt(0).toUpperCase());
    }

    return ownerName;
  }

  return '-';
};

export const isTimeInRange = (time , hoursMap) => {
	let valid = false;
	if(!time || !hoursMap)
		return valid;
	if(!time.includes(":"))
		time = time.slice(0, 2) + ":" + time.slice(2);
	hoursMap.forEach((hour) => {
		if(hour?.close >= time && hour?.open <= time)
			valid= true;
	});

	return valid;
}

export const copyToClipboard = async (str) => {
  await window.navigator.clipboard.writeText(str);
}

export const upperFirst = (str) => {
  return `${str[0].charAt(0).toUpperCase()}${str.slice(1).toLowerCase()}`;
}

export const getSelectedOptionWithDef = (val, options,defOption) => {
  let selOption = defOption;
  if (typeof val === "number") val = val + "";
  if (val && val?.toString().trim().length > 0) {
    selOption = options?.find(
      (option) =>
        option.value.toString().trim().toLowerCase() ===
        val?.toString().trim().toLowerCase()
    );
  }
  return selOption;
};
